import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../firebase';
import '../styles/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      console.log('[Login] Email/password login attempt:', { email });
      await signInWithEmailAndPassword(auth, email, password);
      console.log('[Login] Email/password login success. Navigating to /dashboard');
      navigate('/dashboard');
    } catch (err) {
      console.error('[Login] Email/password login error:', err);
      setError('Error al iniciar sesión. Verifica tus datos.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      // Add scopes if needed
      provider.addScope('email');
      provider.addScope('profile');
      // Set custom parameters
      provider.setCustomParameters({
        prompt: 'select_account'
      });

      const result = await signInWithPopup(auth, provider);
      console.log('[Login] Google login success:', result.user.email);
      // Navegar directamente al dashboard después del popup exitoso
      navigate('/dashboard');
    } catch (err) {
      console.error('[Login] Google login error:', err);
      let errorMessage = 'Error al iniciar sesión con Google.';
      if (err.code === 'auth/popup-closed-by-user') {
        errorMessage = 'El popup de inicio de sesión fue cerrado.';
      } else if (err.code === 'auth/popup-blocked') {
        errorMessage = 'El popup de inicio de sesión fue bloqueado. Permite popups para este sitio.';
      }
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Acceso al Sistema</h2>
        {error && <div className="error-message">⚠️ {error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Correo Electrónico</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="vortex@naval.mil"
            />
          </div>
          <div className="form-group">
            <label>Contraseña de Seguridad</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="••••••••"
            />
          </div>
          <button className="submit-button" type="submit" disabled={loading}>
            {loading ? 'Sincronizando...' : 'Iniciar Sesión Encubierta'}
          </button>
        </form>

        <div className="social-login-separator">O ACCEDER CON</div>

        <button
          className="submit-button google-button"
          onClick={handleGoogleLogin}
          disabled={loading}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="20"
            height="20"
            style={{ flexShrink: 0 }}
            aria-hidden="true"
          >
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
          </svg>
          Acceso Biométrico Google
        </button>
      </div>
    </div>
  );
};

export default Login; 